import React from "react"

import { AirtableApi } from "../../helpers/AirtableApi"

import TwoColumnHeroWithImageRight, {
  CONTAINMENT_MODE,
} from "../_base/TwoColumnHeroWithImageRight"

import { ChildSelector } from "../../helpers/ChildSelector"

import * as formCheckboxWithImageRight from "../../styles/landing_pages/FormCheckboxWithImageRight.module.css"

export default function FormCheckboxWithImageRight(props) {
  const { content } = props

  const [, forceUpdate] = React.useReducer(x => x + 1, 0)

  const [isSubmitted, setSubmitted] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)

  const [data, setData] = React.useState({
    email: ``,
    firstName: ``,
    lastName: ``,
    company: ``,
    registrations: [
      {
        name: `Tue 30 Jul - Find the right fit for your Perspective replacement`,
        checked: false,
      },
      {
        name: `Tue 13 Aug - Enhance user experience and influence decision making`,
        checked: false,
      },
      {
        name: `Thu 15 Aug - Exploring latest options for TM1 Cloud`,
        checked: false,
      },
      {
        name: `Tue 20 Aug - How can Planning Analytics integrate so well with Power BI and your business platforms – Such as Data Lakes, ERP and CRM`,
        checked: false,
      },
      {
        name: `Thu 22 Aug - The DevOps Way - Unit Testing in TM1`,
        checked: false,
      },{
        name: `Tue 27 Aug - Find the right fit for your Perspective replacement`,
        checked: false,
      },
    ],
    notes: ``,
  })

  const handleItemChange = (evt, cat) => {
    let updated = data
    if (Object.keys(evt.target).includes(`checked`)) {
      if (cat) {
        updated[cat].find(({ name }) => name === evt.target.name).checked =
          evt.target.checked
      } else {
        updated[evt.target.name] = evt.target.checked
      }
    } else {
      updated[evt.target.name] = evt.target.value
    }

    setData(updated, forceUpdate())
  }

  const handleSubmit = async evt => {
    evt.preventDefault()

    setHasError(false)

    let filteredData = JSON.parse(JSON.stringify(data))
    filteredData[`registrations`] = data[`registrations`]
      .reduce((prev, curr) => {
        if (curr.checked) return [...prev, curr.name]
        return prev
      }, [])
      .toString()

    try {
      await AirtableApi.writeRecord(
        process.env.GATSBY_AIRTABLE_API_TOKEN,
        `appeFwCDdZsz1chOz`,
        `breakfast-show-form`,
        filteredData,
      )

      setHasError(false)
      setSubmitted(true)
    } catch (error) {
      console.error(error)

      setHasError(true)
    }
  }

  const intro = ChildSelector.select(
    content,
    `intro-text`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const sessions = ChildSelector.select(
    content,
    `header-text`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  return (
    <>
      <div className={`row ${formCheckboxWithImageRight.wrapper}`}>
        <TwoColumnHeroWithImageRight
          contentClass={formCheckboxWithImageRight.content}
          imageHolder={content}
          imageSelector={`media`}
          imageClass={formCheckboxWithImageRight.backgroundImage}
          className={formCheckboxWithImageRight.columnWrapper}
          mode={CONTAINMENT_MODE.normal}
        >
          <div
            className={`row ${formCheckboxWithImageRight.formSubmitWrapper}`}
          >
            <div className={`col ${formCheckboxWithImageRight.formSubmit}`}>
              <h4>{intro}</h4>
              <p>All fields are mandatory *</p>
              <form
                className={`row ${formCheckboxWithImageRight.form}`}
                onSubmit={handleSubmit}
              >
                <div
                  className={`col ${formCheckboxWithImageRight.personalInfo}`}
                >
                  <label htmlFor="firstName">First Name *</label>
                  <input
                    id="firstName"
                    type="text"
                    className="form-control"
                    name="firstName"
                    value={data.firstName}
                    required
                    onChange={handleItemChange}
                  />
                </div>
                <div
                  className={`col ${formCheckboxWithImageRight.personalInfo}`}
                >
                  <label htmlFor="lastName">Last Name *</label>
                  <input
                    id="lastName"
                    type="text"
                    className="form-control"
                    name="lastName"
                    value={data.lastName}
                    required
                    onChange={handleItemChange}
                  />
                </div>
                <div
                  className={`col ${formCheckboxWithImageRight.personalInfo}`}
                >
                  <label htmlFor="email">Email *</label>
                  <input
                    id="email"
                    type="email"
                    className="form-control"
                    aria-label="Email"
                    name="email"
                    value={data.email}
                    required
                    onChange={handleItemChange}
                  />
                </div>
                <div
                  className={`col ${formCheckboxWithImageRight.personalInfo}`}
                >
                  <label htmlFor="company">Company *</label>
                  <input
                    id="company"
                    type="text"
                    className="form-control"
                    name="company"
                    value={data.company}
                    required
                    onChange={handleItemChange}
                  />
                </div>
                <div
                  className={`row ${formCheckboxWithImageRight.optionWrapper}`}
                >
                  <div
                    className={`col ${formCheckboxWithImageRight.optionHeader}`}
                  >
                    <p>{sessions}</p>
                  </div>

                  {data.registrations.map((it, idx) => (
                    <div
                      key={idx}
                      className={`col ${formCheckboxWithImageRight.option}`}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name={it.name}
                        checked={data.registrations[idx].checked}
                        onChange={evt => handleItemChange(evt, `registrations`)}
                      />
                      <label className="form-check-label">{it.name}</label>
                    </div>
                  ))}

                  <div className={`col ${formCheckboxWithImageRight.message}`}>
                    <label htmlFor="notes">
                      Do you have any dietary restrictions or special dietary
                      preferences? If so, please let us know in the box below.*
                    </label>
                    <textarea
                      className="form-control"
                      name="notes"
                      rows="3"
                      values={data.notes}
                      onChange={handleItemChange}
                    ></textarea>
                  </div>
                </div>

                <div className={`col ${formCheckboxWithImageRight.validation}`}>
                  <input
                    id="optin"
                    type="checkbox"
                    className="form-check-input"
                    required
                  />
                  <label htmlFor="optin">
                    We would like your permission to reach out to you with more
                    information about our products and services. We will only
                    send you marketing information we think will be relevant to
                    you. We will always treat your personal details with the
                    utmost care and will never sell them to other companies for
                    marketing purposes.
                  </label>
                </div>
                <div
                  className={`row ${formCheckboxWithImageRight.submitSection}`}
                >
                  <div
                    className={`col ${formCheckboxWithImageRight.submitBtn}`}
                  >
                    <button
                      type="submit"
                      className={`${formCheckboxWithImageRight.btn}`}
                    >
                      Register
                    </button>
                    {hasError && (
                      <p>
                        An unexpected error has occurred. Please confirm all
                        data to be correctly input and try again...
                      </p>
                    )}
                    {isSubmitted && (
                      <p>
                        Thank you for your interest! You will receive an e-mail
                        shortly with a follow up.
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </TwoColumnHeroWithImageRight>
      </div>
    </>
  )
}
